<router-outlet></router-outlet>


<ng-http-loader
  [debounceDelay]="1000"
  [filteredUrlPatterns]="noAjaxSpinnerUrls">
</ng-http-loader>
